import { CSSProperties } from "react";

export enum ScreenSizes {
  THUMB_120 = 120,
  MOBILE_480 = 480,
  MOBILE_768 = 768,
  DESKTOP_1200 = 1200,
  DESKTOP_1440 = 1440,
  DESKTOP_1920 = 1920
}

export enum RequiredImageOptions {
  IMAGE_WIDE = "imageWide",
  IMAGE_NARROW = "imageNarrow",
  IMAGE_PLACEHOLDER = 'placeholderImage'
}

export enum EcImageAttributes {
  ALT = 'ec-image'
}

export interface Props {
  imageWide?: string;
  imageNarrow?: string;
  placeholderImage?: string;
  width?: number;
  height?: number;
  widthAuto?: boolean;
  heightAuto?: boolean;
  maxBreackpoint?: ScreenSizes;
  minBreackpoint?: ScreenSizes;
  excludeBreakPoints?: ScreenSizes[];
  alt?: string;
  classes?: string[];
  onMouseEnter?: (e: any) => void;
  onMouseMove?: (e: any) => void;
  onMouseLeave?: (e: any) => void;
  ref?: any,
  style?: CSSProperties,
  draggable?: boolean,
  fetchPriority?: 'high' | 'low' | 'auto',
}

export type AtLeastOne<T, Keys extends keyof T = keyof T> =
  Pick<T, Exclude<keyof T, Keys>> & { [K in Keys]-?: Required<Pick<T, K>> }[Keys];

export type RequiredImageProps = AtLeastOne<Props, RequiredImageOptions.IMAGE_WIDE | RequiredImageOptions.IMAGE_NARROW | RequiredImageOptions.IMAGE_PLACEHOLDER>;

interface LoaderProps {
  src: string;
  macro: number;
  isWebp?: boolean;
}

export function cubesImageLoader({ src, macro, isWebp = true }: LoaderProps) {
  let baseUrl = process.env.NEXT_PUBLIC_APP_URL;
  let urlObj: URL | undefined = undefined;
  if(!src.startsWith(baseUrl)){
    src = baseUrl + src;
  }
  try {
    urlObj = new URL(src);
  } catch (error) {
    return baseUrl + (src.startsWith('/') ? src : `/${src}`);
  }
  if (urlObj.pathname.endsWith('.svg')) {
    return baseUrl + urlObj.pathname;
  }
  let parseSrc: string = urlObj.pathname.replace(/^\/storage\/file-manager/, '');
  // let queryString: string = `${query.heightAuto || query.widthAuto ? '?' : '' + (query.heightAuto ? 'height_auto=1' : '') + (query.widthAuto ? 'width_auto=1' : '')}`;
  //skloni sam uslov za webp,stavljao mi je duplo na mobile
  // return `${baseUrl}/storage/thumbs/${macro}${parseSrc}${isWebp ? '.webp' : ''}`;
  return `${baseUrl}/storage/thumbs/${macro}${parseSrc}`;
}

const CubesImage = ({
  imageWide,
  imageNarrow,
  placeholderImage = '/',
  width,
  height,
  maxBreackpoint = ScreenSizes.DESKTOP_1920,
  minBreackpoint = ScreenSizes.THUMB_120,
  excludeBreakPoints = [],
  alt = EcImageAttributes.ALT,
  classes = [],
  onMouseEnter,
  onMouseMove,
  onMouseLeave,
  ref,
  style,
  draggable = true,
  fetchPriority = 'auto'
}: RequiredImageProps) => {

  return (
    <picture className={`${classes.join(' ')}`}>
      {
        !imageNarrow?.endsWith('.svg')
          ?
          <>
            {
              !excludeBreakPoints.find(bPoint => bPoint == ScreenSizes.THUMB_120) && imageNarrow && maxBreackpoint >= ScreenSizes.THUMB_120 && minBreackpoint <= ScreenSizes.THUMB_120
                ?
                <source srcSet={cubesImageLoader({ macro: ScreenSizes.THUMB_120, src: imageNarrow })} media={maxBreackpoint == ScreenSizes.THUMB_120 ? undefined : `(max-width: ${ScreenSizes.THUMB_120}px)`} type="image/webp" width={width} height={height} />
                :
                <></>
            }
            {
              !excludeBreakPoints.find(bPoint => bPoint == ScreenSizes.THUMB_120) && imageNarrow && maxBreackpoint >= ScreenSizes.THUMB_120 && minBreackpoint <= ScreenSizes.THUMB_120
                ?
                <source srcSet={cubesImageLoader({ macro: ScreenSizes.THUMB_120, src: imageNarrow, isWebp: false })} media={maxBreackpoint == ScreenSizes.THUMB_120 ? undefined : `(max-width: ${ScreenSizes.THUMB_120}px)`} type="image/jpeg" width={width} height={height} />
                :
                <></>
            }
            {
              !excludeBreakPoints.find(bPoint => bPoint == ScreenSizes.MOBILE_480) && imageNarrow && maxBreackpoint >= ScreenSizes.MOBILE_480 && minBreackpoint <= ScreenSizes.MOBILE_480
                ?
                <source srcSet={cubesImageLoader({ macro: ScreenSizes.MOBILE_480, src: imageNarrow })} media={maxBreackpoint == ScreenSizes.MOBILE_480 ? undefined : `(max-width: ${ScreenSizes.MOBILE_480}px)`} type="image/webp" width={width} height={height} />
                :
                <></>
            }
            {
              !excludeBreakPoints.find(bPoint => bPoint == ScreenSizes.MOBILE_480) && imageNarrow && maxBreackpoint >= ScreenSizes.MOBILE_480 && minBreackpoint <= ScreenSizes.MOBILE_480
                ?
                <source srcSet={cubesImageLoader({ macro: ScreenSizes.MOBILE_480, src: imageNarrow, isWebp: false })} media={maxBreackpoint == ScreenSizes.MOBILE_480 ? undefined : `(max-width: ${ScreenSizes.MOBILE_480}px)`} type="image/jpeg" width={width} height={height} />
                :
                <></>
            }
            {
              !excludeBreakPoints.find(bPoint => bPoint == ScreenSizes.MOBILE_768) && imageNarrow && maxBreackpoint >= ScreenSizes.MOBILE_768 && minBreackpoint <= ScreenSizes.MOBILE_768
                ?
                <source srcSet={cubesImageLoader({ macro: ScreenSizes.MOBILE_768, src: imageNarrow })} media={maxBreackpoint == ScreenSizes.MOBILE_768 ? undefined : `(max-width: ${ScreenSizes.MOBILE_768}px)`} type="image/webp" width={width} height={height} />
                :
                <></>
            }
            {
              !excludeBreakPoints.find(bPoint => bPoint == ScreenSizes.MOBILE_768) && imageNarrow && maxBreackpoint >= ScreenSizes.MOBILE_768 && minBreackpoint <= ScreenSizes.MOBILE_768
                ?
                <source srcSet={cubesImageLoader({ macro: ScreenSizes.MOBILE_768, src: imageNarrow, isWebp: false })} media={maxBreackpoint == ScreenSizes.MOBILE_768 ? undefined : `(max-width: ${ScreenSizes.MOBILE_768}px)`} type="image/jpeg" width={width} height={height} />
                :
                <></>
            }
          </>
          :
          <></>
      }
      {
        !imageWide?.endsWith('.svg')
          ?
          <>
            {
              !excludeBreakPoints.find(bPoint => bPoint == ScreenSizes.DESKTOP_1200) && imageWide && maxBreackpoint >= ScreenSizes.DESKTOP_1200
                ?
                <source srcSet={cubesImageLoader({ macro: ScreenSizes.DESKTOP_1200, src: imageWide })} media={maxBreackpoint == ScreenSizes.DESKTOP_1200 ? undefined : `(max-width: ${ScreenSizes.DESKTOP_1200}px)`} type="image/webp" width={width} height={height} />
                :
                <></>
            }
            {
              !excludeBreakPoints.find(bPoint => bPoint == ScreenSizes.DESKTOP_1200) && imageWide && maxBreackpoint >= ScreenSizes.DESKTOP_1200
                ?
                <source srcSet={cubesImageLoader({ macro: ScreenSizes.DESKTOP_1200, src: imageWide, isWebp: false })} media={maxBreackpoint == ScreenSizes.DESKTOP_1200 ? undefined : `(max-width: ${ScreenSizes.DESKTOP_1200}px)`} type="image/jpeg" width={width} height={height} />
                :
                <></>
            }
            {
              !excludeBreakPoints.find(bPoint => bPoint == ScreenSizes.DESKTOP_1440) && imageWide && maxBreackpoint >= ScreenSizes.DESKTOP_1440
                ?
                <source srcSet={cubesImageLoader({ macro: ScreenSizes.DESKTOP_1440, src: imageWide })} media={maxBreackpoint == ScreenSizes.DESKTOP_1440 ? undefined : `(max-width: ${ScreenSizes.DESKTOP_1440}px)`} type="image/webp" width={width} height={height} />
                :
                <></>
            }
            {
              !excludeBreakPoints.find(bPoint => bPoint == ScreenSizes.DESKTOP_1440) && imageWide && maxBreackpoint >= ScreenSizes.DESKTOP_1440
                ?
                <source srcSet={cubesImageLoader({ macro: ScreenSizes.DESKTOP_1440, src: imageWide, isWebp: false })} media={maxBreackpoint == ScreenSizes.DESKTOP_1440 ? undefined : `(max-width: ${ScreenSizes.DESKTOP_1440}px)`} type="image/jpeg" width={width} height={height} />
                :
                <></>
            }
            {
              !excludeBreakPoints.find(bPoint => bPoint == ScreenSizes.DESKTOP_1920) && imageWide && maxBreackpoint >= ScreenSizes.DESKTOP_1920
                ?
                <source srcSet={cubesImageLoader({ macro: ScreenSizes.DESKTOP_1920, src: imageWide })} type="image/webp" width={width} height={height} />
                :
                <></>
            }
            {
              !excludeBreakPoints.find(bPoint => bPoint == ScreenSizes.DESKTOP_1920) && imageWide && maxBreackpoint >= ScreenSizes.DESKTOP_1920
                ?
                <source srcSet={cubesImageLoader({ macro: ScreenSizes.DESKTOP_1920, src: imageWide, isWebp: false })} type="image/jpeg" width={width} height={height} />
                :
                <></>
            }
          </>
          :
          <></>
      }
      <img
        src={
          imageNarrow || imageWide
            ?
            cubesImageLoader({
              macro: ScreenSizes.MOBILE_768,
              src: imageNarrow ?? imageWide ?? '/',
              isWebp: false,
            })
            :
            placeholderImage
        }
        width={width}
        height={height}
        alt={alt}
        onMouseEnter={onMouseEnter}
        onMouseMove={onMouseMove}
        onMouseLeave={onMouseLeave}
        ref={ref}
        style={style}
        className={`${classes.join(' ')}`}
        draggable={draggable}
        fetchPriority={fetchPriority}
      />
    </picture>
  )
}

export default CubesImage;